"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _getEnabledFeatures = require("./getEnabledFeatures");
Object.keys(_getEnabledFeatures).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _getEnabledFeatures[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _getEnabledFeatures[key];
    }
  });
});
var _getFeatureToggles = require("./getFeatureToggles");
Object.keys(_getFeatureToggles).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _getFeatureToggles[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _getFeatureToggles[key];
    }
  });
});
//# sourceMappingURL=index.js.map